/**
 * theme-animations.js
 */
const initScrollAnimations = () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    let isMobile = false
    isMobile = window?.innerWidth <= 768
    gsap.registerPlugin(ScrollTrigger);

    // 选取还没初始化过的元素
    const revealElements = document.querySelectorAll('.scroll-fade-in:not(.is-animating)');

    revealElements.forEach((el) => {
        const d = parseFloat(isMobile ? el.dataset.delaym ? el.dataset.delaym : el.dataset.delay : el.dataset.delay) || 0;
        if(isMobile && el.dataset.nodelaym == true) return
        // 位移
        gsap.from(el, {
            y: 30,
            ease: "power1.out",
            duration: 0.9,
            delay: d,
            scrollTrigger: {
                trigger: el,
                start: "top 82%",
                toggleActions: "restart none none reverse"
            }
        });

        // 透明度
        gsap.from(el, {
            opacity: 0,
            ease: "power2.out",
            duration: 0.7,
            delay: d,
            scrollTrigger: {
                trigger: el,
                start: "top 82%",
                toggleActions: "restart none none reverse"
            }
        });

        // 标记已处理
        el.classList.add('is-animating');
    });
};

// 直接执行！因为有 defer，执行时 DOM 肯定已经好了
initScrollAnimations();

// 保底：处理图片懒加载后的位置重算
window.addEventListener('load', () => ScrollTrigger?.refresh());
// 针对 Shopify 编辑器的实时预览补丁
document.addEventListener('shopify:section:load', initScrollAnimations);

const initStepAnimations = () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    // 选取还没初始化过的元素
    const stepCon = document.querySelector('.stepimpact-stats');
    if(!stepCon) return
    let e = stepCon.children,
        w = stepCon.parentElement,
        t = gsap.timeline({
            scrollTrigger: {
                trigger: w,
                start: "top center",
                end: "bottom bottom",
                toggleActions: "restart none none reverse"
            }
        });
        window.innerWidth > 1024 ? t.from(e, {
            opacity: 0,
            y: "100%",
            stagger: .05,
            duration: 1
        }) : t.from(e, {
            opacity: 0,
            x: "-100%",
            stagger: .05,
            duration: 1
        })
};

// 直接执行！因为有 defer，执行时 DOM 肯定已经好了
initStepAnimations();

// 针对 Shopify 编辑器的实时预览补丁
document.addEventListener('shopify:section:load', initStepAnimations);

const debounceRefreshScrollTrigger = (func, wait) => {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
};

const refreshScrollTrigger = debounceRefreshScrollTrigger(() => {
    if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh();
    }
}, 300); 

const initSmartResizeObserver = () => {
    const looxContainer = document.querySelector('#looxReviews'); 
    
    if (!looxContainer) return;

    const resizeObserver = new ResizeObserver(() => {
        refreshScrollTrigger();
    });
    resizeObserver.observe(looxContainer);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmartResizeObserver);
} else {
    initSmartResizeObserver();
}